<template>
  <div>
    <v-dialog v-model="show" persistent max-width="70%">
      <v-card>
        <v-app-bar dark text color="secondary">
          <v-toolbar-title class="subheading">{{ $t("moduletemplates.title") }}</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-form ref="form" @submit.prevent="filter" class="mt-8 mr-4 d-none d-sm-flex">
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs4>
                  <v-autocomplete
                    name="coursetype.coursetypegroup_id"
                    v-model="search_params.coursetypegroup_id"
                    :items="coursetypegroups"
                    item-text="name"
                    item-value="id"
                    :label="$t('coursetypegroups.title')"
                    autocomplete="new-password"
                    @change="filter('reset-coursetype')"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs4>
                  <v-select
                    v-model="search_params.coursetype_id"
                    :items="coursetypes"
                    item-text="fullname"
                    item-value="id"
                    :label="$t('coursetypes.title')"
                    @change="filter"
                    hide-details
                    clearable
                  ></v-select>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    :label="$t('global.search')"
                    v-model="search_params.any"
                    @keydown="checkKeyPress"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>

          <action-button type="save" @click="submit" />
          <action-button type="cancel" @click="cancel" />
        </v-app-bar>

        <v-divider></v-divider>

        <v-card-text class="py-0 mt-4">
          <v-data-table
            :headers="headers"
            :items="moduletemplates"
            :items-per-page="moduletemplates.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            item-key="id"
            :show-select="true"
            v-model="selected"
            :must-sort="true"
          >
            <template v-slot:item.coursetype_id="{ item }">
              {{ item.coursetype != null ? item.coursetype.name : "" }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ModuleTemplateListPopup",

  props: {
    show: {
      type: Boolean,
      required: true
    },
    except_ids: {
      type: Array
    }
  },

  data() {
    return {
      url: "",
      selected: [],
      moduletemplates: [],

      allcoursetypes: [],
      coursetypes: [],
      coursetypegroups: [],

      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["name"],
        sortDesc: []
      },
      search_params: {
        not_in_ids: "",
        title: "",
        any: "",
        coursetype_id: "",
        coursetypegroup_id: ""
      }
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("moduletemplates.name"), value: "name" },
          {
            text: this.$t("moduletemplates.coursetype_id"),
            value: "coursetype_id"
          },
          { text: this.$t("moduletemplates.req_hours"), value: "req_hours" },
          { text: this.$t("moduletemplates.price"), value: "price" },
          {
            text: this.$t("moduletemplates.req_module_id"),
            value: "req_module_id"
          },
          { text: this.$t("moduletemplates.status"), value: "status" }
        ]
      }
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          this.list()
        }
      }
    },
    pagination: {
      handler() {
        this.refresh = true
      }
    },
    show: {
      handler(val) {
        if (val) {
          this.selected = []
          this.moduletemplates = []
          this.list()
        }
      }
    }
  },

  mounted() {
    this.url = this.API_URL + "moduletemplates"
  },

  created() {
    this.loadDropdowns()
  },

  methods: {
    list() {
      this.show_loading = true
      this.search_params.not_in_ids = this.except_ids ? this.except_ids.join(",") : null

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      axios.get(this.url + "?" + query).then((res) => {
        this.moduletemplates = res.data.data
        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false

        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    },

    loadDropdowns() {
      let lists = [
        {
          key: "coursetypegroups",
          module: "coursetypegroups",
          query: "show_all=true&sort_by=category&sort_order=asc"
        },
        { key: "coursetypes", module: "coursetypes", query: "show_all=true" }
      ]

      axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
        this.coursetypegroups = res.data.coursetypegroups
        this.allcoursetypes = res.data.coursetypes

        this.coursetypes = this.allcoursetypes
      })
    },

    filter(action = null) {
      if (action == "reset-coursetype") {
        this.search_params.coursetype_id = ""
      }

      if (this.search_params.coursetypegroup_id) {
        this.coursetypes = this.allcoursetypes.filter((i) => i.coursetypegroup_id == this.search_params.coursetypegroup_id)
      } else {
        this.coursetypes = this.allcoursetypes
      }

      this.pagination.page = 1
      this.refresh = true
    },

    reset() {
      this.$refs.form.reset()
      this.pagination.page = 1
      this.refresh = true
    },

    cancel() {
      this.$emit("callback_modtemplistpopup_cancel")
    },

    submit() {
      this.$emit("callback_modtemplistpopup_submit", this.selected)
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    }
  }
}
</script>

<style scoped></style>
